import {
  billingStatusSchema,
  checkoutResultSchema,
  confirmCheckoutSchema,
  createCheckoutSchema,
  createPortalSchema,
  portalResultSchema,
  type BillingStatus,
  type ConfirmCheckoutPayload,
  type CheckoutResult,
  type CreateCheckoutPayload,
  type CreatePortalPayload,
  type PortalResult,
} from "@io-spoke/contracts/billing";
import { getApiClient } from "./apiClient";

export async function getBillingStatus(): Promise<BillingStatus> {
  const response = await getApiClient().get<{ billing: unknown }>("/billing/status");
  const parsed = billingStatusSchema.safeParse(response.data.billing);
  if (!parsed.success) {
    throw new Error("Billing status returned an invalid response.");
  }
  return parsed.data;
}

export async function confirmSubscriptionCheckout(
  payload: ConfirmCheckoutPayload
): Promise<CheckoutResult> {
  const parsedPayload = confirmCheckoutSchema.safeParse(payload);
  if (!parsedPayload.success) {
    throw new Error(parsedPayload.error.issues[0]?.message ?? "Invalid checkout confirmation.");
  }
  const response = await getApiClient().post<unknown>("/billing/checkout/confirm", parsedPayload.data);
  const parsedResponse = checkoutResultSchema.safeParse(response.data);
  if (!parsedResponse.success) throw new Error("Checkout confirmation returned an invalid response.");
  return parsedResponse.data;
}

export async function createCustomerPortal(
  payload: CreatePortalPayload = {}
): Promise<PortalResult> {
  const parsedPayload = createPortalSchema.safeParse(payload);
  if (!parsedPayload.success) {
    throw new Error(parsedPayload.error.issues[0]?.message ?? "Invalid portal payload.");
  }
  const response = await getApiClient().post<unknown>("/billing/portal", parsedPayload.data);
  const parsedResponse = portalResultSchema.safeParse(response.data);
  if (!parsedResponse.success) throw new Error("Billing portal returned an invalid response.");
  return parsedResponse.data;
}

export async function createSubscriptionCheckout(
  payload: CreateCheckoutPayload = {}
): Promise<CheckoutResult> {
  const parsedPayload = createCheckoutSchema.safeParse(payload);
  if (!parsedPayload.success) {
    throw new Error(
      parsedPayload.error.issues[0]?.message ?? "Invalid checkout payload."
    );
  }
  const response = await getApiClient().post<unknown>(
    "/billing/checkout",
    parsedPayload.data
  );
  const parsedResponse = checkoutResultSchema.safeParse(response.data);
  if (!parsedResponse.success) {
    throw new Error("Checkout returned an invalid response.");
  }
  return parsedResponse.data;
}
